import { ErrorHandler, Injectable } from '@angular/core';
import { DatadogService } from '../datadog/datadog.service';
import { quickWebLogger } from '@quickweb/logger';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private datadogService: DatadogService) {}

  handleError(error: any): void {
    let customMessage = '';
  
    // Verifica se o erro é uma Promise rejeitada
    if (error.rejection) {
      const rejection = error.rejection;
  
      // Verifica se a mensagem contém "Nenhum Link com a relation"
      if (rejection.message && rejection.message.includes("Nenhum Link com a relation")) {
        const relation = rejection.message.match(/relation '([^']+)'/);
        const relName = relation ? relation[1] : "desconhecido";
        customMessage = `Erro ao localizar o rel '${relName}'. Verifique se ele está configurado corretamente.`;      } 
      
      else if (rejection.status === 0 || rejection.message?.includes('Failed to fetch') || rejection.message?.includes('Network Error')) {
        customMessage = 'A API está indisponível. Verifique sua conexão ou tente novamente mais tarde.';
      } 
      else {
        customMessage = rejection.message || rejection.toString();
      }
  
      const errorEvent = {
        message: customMessage,
        name: rejection.name || 'Error',
        stack: rejection.stack || '',
        url: window.location.href,
        timestamp: new Date().toISOString(),
        status: rejection.status || 'N/A',
      };
  
      console.log("Promise rejection tratado:", errorEvent);
      quickWebLogger.logger.error('GlobalErrorHandler', errorEvent);
      console.error('GlobalErrorHandler:', customMessage);
    } else {
      // Trata erros normais
      customMessage = error.message || error.toString();
  
      const errorEvent = {
        message: customMessage,
        name: error.name || 'Error',
        stack: error.stack || '',
        url: window.location.href,
        timestamp: new Date().toISOString(),
      };
  
      console.log("Erro tratado:", errorEvent);
      quickWebLogger.logger.error('GlobalErrorHandler', errorEvent);
      console.error('GlobalErrorHandler:', customMessage);
    }
  }

}